import React from 'react';
 
export default function CampoFicha({ rotulo, valor, largura = "col-6" }) {
    return (
        <div className={largura}>
            <p className="fw-regular mb-2">
                <span className="fw-bold">{rotulo}: </span>{valor}
            </p>
        </div>
    );
}
